<template>
<div class="dm-rounded dm-obj dm-flex">
    <div v-if="label" @click="select('/l')" class="rounded">{{label}}</div>
    <div v-if="part == null" class="rounded val">null</div>
    <MItem v-else v-for="(item, index) in part" :key="index" :sel="sel" :rprefix="rprefix + '/i' + index" :prefix="prefix + '/i'" :part="item" :label="index" :index="index" />
</div>
</template>

<script>
export default {
    name: 'MObject',
    props: {
        label: String,
        part: Object,
        prefix: String,
        rprefix: String,
        sel: Object,
    },
    components: {
        MItem: () => import('./MItem.vue'),
    },
    methods: {
        isObject: function (o) {
            return typeof o == "object"
        },
        select(suffix) {
            this.$root.$emit('selected', {
                selection: this.rprefix + suffix,
                path: this.prefix + suffix
            })
        },
        isSelected(suffix) {
            return this.sel.selected == this.rprefix + suffix
        },
        inSelection(suffix) {
            return this.sel.selection.includes(this.rprefix + suffix)
        },
    },
}
</script>
